import { Button } from "@/components/ui/button";

import { PlusIcon } from "lucide-react";

type IngredientsToolbarProps = {
  canManage: boolean;
  canBulkAssign?: boolean;
  selectedCount?: number;
  onCreate: () => void;
  onBulkAssign?: () => void;
};

export function IngredientsToolbar({
  canManage,
  canBulkAssign,
  selectedCount = 0,
  onCreate,
  onBulkAssign,
}: IngredientsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div className="flex flex-col">
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            ວັດຖຸດິບ
          </h2>
          <p className="text-muted-foreground">
            ຈັດການວັດຖຸດິບ ແລະ ຫນ່ວຍພື້ນຖານສຳລັບສູດ ແລະ ສາງ.
          </p>
        </div>
        {(canManage || canBulkAssign) && (
          <div className="flex items-center space-x-2">
            {canBulkAssign && selectedCount > 0 && onBulkAssign ? (
              <Button variant="outline" onClick={onBulkAssign}>
                ມອບຫມວດ ({selectedCount.toLocaleString("lo-LA")})
              </Button>
            ) : null}
            {canManage ? (
              <Button onClick={onCreate}>
                <PlusIcon className="h-4 w-4" />
                ສ້າງວັດຖຸດິບ
              </Button>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
